import Button from "../../components/button";
import { Link, useNavigate } from "react-router-dom";
import signIn from "../../assets/icons/signIn.svg";
import Navbar from "../../components/navbar";
import Input from "../../components/input";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { generate_token, reset_password } from "../../hooks/local/reducer";
import { showErrorMessage, showSuccessMessage } from "../../hooks/constants";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import animationData from "../../assets/animations/messageAnimation_2.json"

const PasswordResetToken = () => {

  const [tokenForm, setTokenForm] = useState(true) 
  const [tokenGeneratedModal, setTokenGeneratedModal] = useState(false)
  const [resetForm, setResetForm] = useState(false)

  const [emailAddress, setEmailAddress] = useState("")
  
  const closeModal = () => {
    setTokenGeneratedModal(false);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.user.loading); 
  document.title = `${loading? "Mosquepay" : "Reset password - Mosquepay"}`;

  const generateTokenForm = useFormik({
    initialValues:{
      email: emailAddress,
      operation_type: "FORGET-PASSWORD",
    },
    validationSchema: Yup.object({
      email: Yup.string()
      .required("Your email address is required")
      .email("Please enter a valid email address"),
    }),
    onSubmit: async(values) => {
      const {email, operation_type} = values;
      let generateTokenData = {email, operation_type};
      const payload = await dispatch(generate_token(generateTokenData));
      // console.log(payload);
      if(payload.payload.status_code === "0") {
        // console.log(payload.payload.message);
        showSuccessMessage("Token generated successfully");
        setTokenGeneratedModal(true);
        setTokenForm(false);
        setResetForm(true);
        setEmailAddress(email)
      }
    }
  })

  const resetPasswordForm = useFormik({
    initialValues:{
      email: "",
      operation_type: "FORGET-PASSWORD",
      token: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
      .required("Your email address is required"),
      token: Yup.string()
      .required("Token is required to reset your password"),
      password: Yup.string()
      .required("Password cannot be empty")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@.$!%#?&])[A-Za-z\d@.$!%*#?&]{8,}$/,
        "Please check password requirement information"
      ),
      confirmPassword: Yup.string()
      .required("Confirm Password!")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: async(values, {resetForm}) => {
      const {email, operation_type, token, password} = values;
      let resetPasswordData = {email , operation_type, token, password};
      const payload = await dispatch(reset_password(resetPasswordData));
      // console.log(payload, resetPasswordData);
      if(payload.payload.status_code === "0") {
        // console.log(payload.payload.message);
        showSuccessMessage("Password has been reset");
        resetForm();
        navigate("/sign-in")
      } else {
        showErrorMessage(payload.payload.message)
      }
    }
  })

  useEffect(() => {
    if (emailAddress) {
      resetPasswordForm.setFieldValue("email", emailAddress);
    }
  }, [emailAddress]); // Runs whenever emailAddress changes


    return ( 
        <div className="bg-signInPattern bg-[length:24%]">
          <div className="bg-white/80 min-h-screen flex items-center pt-24 pb-16">
            {/* navbar */}
            <Navbar />
            <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-4 w-full">
               {tokenForm && (
                <div className="bg-white rounded border lg:col-span-2 p-4 md:p-10">
                  <p className="font-bold">Forgot your password?</p>
                  <p className="text-secondary leading-tight mt text-sm">Please provide the email address you used to create your mosquepay account.</p>
                  <form onSubmit={generateTokenForm.handleSubmit} className="mt-6 grid gap-4">
                    <Input
                     type={"email"}
                     label={"Email address"}
                     placeholder={"Muhammad@gmail.com"}
                     name={"email"}
                     value={generateTokenForm.values.email}
                     onChange={generateTokenForm.handleChange}
                     onBlur={generateTokenForm.handleBlur}
                     onError={generateTokenForm.touched.email && generateTokenForm.errors.email ? generateTokenForm.errors.email : null}
                    />
                    <Button buttonText={"Continue"} icon={signIn} loading={loading} otherStyles={"bg-black text-white"}/>
                  </form>
                  <p className="mt-6">Back to<Link to={"/sign-in"} className="underline text-brandGreen ps-1">sign in</Link></p>
                </div>
               )}
               {resetForm &&(
                <div className="bg-white rounded border lg:col-span-3 p-4 md:p-10">
                  <p className="font-bold">Reset your password</p>
                  <p className="text-secondary leading-tight mt text-sm">Use the token that was sent to your email to reset your password.</p>
                  <form onSubmit={resetPasswordForm.handleSubmit} className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                   type={"email"}
                   label={"Email address"}
                   value={resetPasswordForm.values.email}
                   disabled={true}
                   name={"email"}
                  />
                  <Input
                   type={"text"}
                   label={"Token"}
                   name={"token"}
                   value={resetPasswordForm.values.token}
                   onChange={resetPasswordForm.handleChange}
                   onBlur={resetPasswordForm.handleBlur}
                   onError={
                    resetPasswordForm.touched.token && resetPasswordForm.errors.token
                      ? resetPasswordForm.errors.token
                      : null}
                  />
                  <Input
                   type={"password"}
                   label={"New password"}
                   name={"password"}
                   isPassword={"true"}
                   value={resetPasswordForm.values.password}
                   onChange={resetPasswordForm.handleChange}
                   onBlur={resetPasswordForm.handleBlur}
                   onError={
                    resetPasswordForm.touched.password && resetPasswordForm.errors.password
                      ? resetPasswordForm.errors.password
                      : null}
                  />
                  <Input
                   type={"password"}
                   label={"Confirm password"}
                   name={"confirmPassword"}
                   isPassword={"true"}
                   value={resetPasswordForm.values.confirmPassword}
                   onChange={resetPasswordForm.handleChange}
                   onBlur={resetPasswordForm.handleBlur}
                   onError={
                    resetPasswordForm.touched.confirmPassword && resetPasswordForm.errors.confirmPassword
                      ? resetPasswordForm.errors.confirmPassword
                      : null}
                  />
                 
                  <Button buttonText={"Reset password"} loading={loading} otherStyles={"bg-black text-white"}/>
                  </form>
                </div>
               )}
              <div className="lg:col-span-2 p-4 md:p-10">
                 <div className="h-full flex items-center">
                   <div className="text-center lg:text-start">
                     <p>“Those who spend their wealth in Allah’s cause are like grains of corn which produce seven ears, each bearing a hundred grains.”</p>
                     <p className="font-bold mt-2">Qur’an, 2:261</p>
                   </div>
                 </div>
              </div>
            </div>
          </div>

          {tokenGeneratedModal && (
          <div className="bg-black/80 fixed top-0 z-50 w-full h-full transition-all duration-300 flex items-center justify-center">
            <div className="bg-white rounded-md border border-[#c4c4c424] w-full md:w-1/2 lg:w-1/3 m-4 py-10 px-4 md:px-8 overflow-y-auto">
             <div className="flex justify-center">
               <Lottie animationData={animationData} loop={true} className="w-40"/>
             </div>
             <p className="font-bold text-center mb-2 mt-6">Check your inbox</p>
              <p className="text-center pb-6">We've sent a token to <span className="text-brandGreen underline">{generateTokenForm.values.email}</span>. Please use the token to reset your password.
              If you don't see the email within a few minutes, check your spam or junk folder.
              </p>
              <div className="flex justify-center">
              <Button buttonRole={"custom"} onClick={closeModal} buttonText={"Okay"} otherStyles={"bg-black text-white"}/>
              </div>
            </div>
          </div>
        )}
        </div>
     );
}
 
export default PasswordResetToken;